import _ from 'lodash';
import React, { useEffect, useState, useRef } from 'react';
import { withAlert } from 'react-alert';
import { compose } from 'redux';
import { Row, Form, Input, Button, Divider, DatePicker, Select, Checkbox } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { FileUploader } from 'react-drag-drop-files';
import HtmlParser from 'html-react-parser';
import LocalStorageHelper from '../../helpers/local_storage';
import Loading from '../../components/loading';
import HeroImage from '../../assets/hero.jpg';

const { TextArea } = Input;


const defaultState = {
	user_remarks: null,
	email: LocalStorageHelper.getEmail(),
	name: LocalStorageHelper.getUsername(),
	phone_number: null,
	incident_date: null,
	incident_type: null,
	categories: [],
	sub_categories: [],
	attachments: [],
	details: null,
	share_info: false,
	disableButton: true,
	loading: false
};

function WebFormDetailPage(props) {
	const { pageProps, getCategories, getIncidentTypes, getWebFormConfiguration } = props;

	const [form] = Form.useForm();
	const prevPropsRef = useRef();
	const [formState, setFormState] = useState(defaultState);
	const [subCategoriesOptions, setSubCategoriesOptions] = useState([]);

	const {
		incident_types,
		categories: propsCategories,
		loadingSubmit,
		loading,
		web_form
	} = props.pageProps;

	const {
		incident_date,
		incident_type,
		details,
		share_info
	} = formState;

	const category_options = propsCategories.map(category => {
		return { text: category.name, value: category._id };
	});

	const sub_category_options = subCategoriesOptions.map(subCategory => {
		return { text: subCategory.name, value: subCategory._id };
	});

	useEffect(() => {
		getCategories();
		getIncidentTypes();
		getWebFormConfiguration();
		form.setFieldsValue({
			email: LocalStorageHelper.getEmail()
		});
		return () => props.resetPage();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (pageProps && pageProps.meta) {
			const { meta } = pageProps;

			// Show an alert when the component first mounts
			if (!prevPropsRef.current) {
				const alertOptions = {
					type: meta.code === 200 ? 'success' : 'error',
					...(meta.code === 40399 && { timeout: 0 })
				};
				props.alert.show(meta.message, alertOptions);
				props.resetMeta();
			}

			// Check if the meta object has changed
			if (prevPropsRef.current && prevPropsRef.current.meta !== meta) {
				const alertOptions = {
					type: meta.code === 200 ? 'success' : 'error',
					...(meta.code === 40399 && { timeout: 0 })
				};
				props.alert.show(meta.message, alertOptions);
				props.resetMeta();
			}

			// Save the current props for the next update
			prevPropsRef.current = pageProps;
		}
	}, [pageProps, pageProps.meta, props]);

	const checkValues = () => {
		const {
			incident_date,
			incident_type,
			details
		} = formState;

		incident_date && incident_type && details && formState.categories.length > 0 && formState.sub_categories.length > 0 ?
			setFormState(prevFormState => ({ ...prevFormState, disableButton: false })) :
			setFormState(prevFormState => ({ ...prevFormState, disableButton: true }));
	};

	useEffect(() => {
		checkValues();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [incident_date, incident_type, details, formState.categories, formState.attachments, formState.sub_categories]);

	useEffect(() => {
		if (formState.categories.length > 0) {
			const newCategories = propsCategories.filter(data => formState.categories.includes(data._id));
			const tempsubCategories = [];
			newCategories.map(category => {
				if (category.sub_category && category.sub_category.length > 0) {
					const { sub_category } = category;
					sub_category.map(subCat => {
						if (!_.find(tempsubCategories, { _id: subCat._id })) {
							tempsubCategories.push(subCat);
						}
					});
				}
			});
			setSubCategoriesOptions([...tempsubCategories]);
		}
	}, [formState.categories, propsCategories]);

	const onFieldChange = (data) => {
		setFormState({
			...formState,
			[data.name]: data.value
		});
	};

	const handleChangeCategories = (index, value) => {
		const { categories } = formState;
		const newCategories = [...categories];
		if (_.isNil(value)) {
			setFormState({
				...formState,
				categories: [],
				sub_categories: []
			});
			//  clear selected sub category

		} else {
			newCategories[index] = value;
			setFormState({
				...formState,
				categories: newCategories,
				sub_categories: []
			});
		}

		form.setFieldsValue({
			sub_categories_field: undefined
		});

		setSubCategoriesOptions([]);
	};

	const handleChangeSubCategories = (index, value) => {
		const { sub_categories } = formState;
		const newSubCategories = [...sub_categories];

		if (_.isNil(value)) {
			setFormState({ ...formState, sub_categories: [] });
		} else {
			newSubCategories[index] = value;
			setFormState({ ...formState, sub_categories: newSubCategories });
		}
	};

	const handleChangeAttachments = (index, value) => {
		const { attachments } = formState;
		const newAttachments = [...attachments];
		newAttachments[index] = value;
		setFormState({ ...formState, attachments: newAttachments });
	};

	const onSubmit = () => {
		setFormState({ ...formState, loading: true });
		const { disableButton } = formState;
		if (!disableButton) {
			setFormState({ ...formState, disableButton: true });
			props.onSubmit(formState);
		}
		setFormState({ ...formState, loading: false });
	};

	if (loading || !web_form) {
		return (

			<div
				style={{ margin: 12, width: '100%', maxWidth: 800, backgroundColor: '#FFFFFF', padding: 12, borderRadius: 4, marginBottom: 100 }}
			>
				<Loading />
			</div>
		);
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

			<div
				style={{
					position: 'relative',
					width: '100%',
					maxHeight: 300,
					borderBottom: '9px solid #5C8A1C',
					borderTop: '6px solid #986514'
				}}
			>
				<img
					src={HeroImage}
					alt="hero"
					style={{
						width: '100%',
						height: '100%',
						marginBottom: 16,
						minHeight: 200,
						objectFit: 'cover'
					}}
				/>
				<div
					style={{
						position: 'absolute',
						maxWidth: 700,
						// top: -25,
						// right: -25,
						textAlign: 'center',
						width: '40vw',
						left: 0,
						bottom: 25,
						backgroundColor: 'rgba(212, 63, 35, 0.9)',
						display: 'flex',
						justifyContent: 'right',
						color: '#FFFFFF',
						padding: 25
					}}
				>
					<h1
						style={{
							fontFamily: 'Arial',
							color: '#FFFFFF',
							margin: 0,
							fontWeight: 'bold',
							fontSize: 24
						}}
					>
						{web_form.title}
					</h1>
				</div>
			</div>
			<div
				style={{
					margin: 12,
					width: '100%',
					maxWidth: 1070,
					backgroundColor: '#FFFFFF',
					padding: 12,
					borderRadius: 4,
					marginBottom: 100,
					paddingTop: 20
				}}
			>
				{HtmlParser(web_form.description)}
				<Divider />
				<Form
					form={form}
					layout="vertical"
					initialValues={{
						email: formState.email
					}}
				>
					<Form.Item
						name="email"
						label="Email"
						id="email"
					>
						<Input
							disabled={true}
							style={{ width: '100%' }}
						/>
					</Form.Item>
					<Form.Item
						name="incident_date"
						label="Incident Date"
						rules={[
							{ required: true, message: 'Please select date' }
						]}
					>
						<DatePicker
							format="MMMM DD, YYYY HH:mm"
							showTime
							onChange={val => {
								const data = {
									name: 'incident_date',
									value: val
								};
								onFieldChange(data);
							}}
							style={{ width: '100%' }}
						/>
					</Form.Item>
					<Form.Item
						name="incident_type"
						label="Incident Type"
						rules={[
							{ required: true, message: 'Please select incident type' }
						]}
					>
						<Select
							onChange={val => {
								const data = {
									name: 'incident_type',
									value: val
								};
								onFieldChange(data);
							}}
							placeholder="Select incident type"
							options={incident_types.length > 0 ? incident_types : []}
						/>
					</Form.Item>
					<Form.Item
						name="categories_field"
						label="Category"
						rules={[
							{ required: true, message: 'Please select category' }
						]}
					>
						<Select
							onChange={val => handleChangeCategories(0, val)}
							allowClear
							placeholder="Select category"
						>
							{
								category_options.length > 0 && category_options.map((option, index) => (
									<Select.Option
										key={index}
										value={option.value}
									>{option.text}</Select.Option>
								))
							}
						</Select>
					</Form.Item>
					{
						formState && formState.categories.length > 0 ? (
							<Form.Item
								name="sub_categories_field"
								label="Sub-Category"
								rules={[
									{ required: true, message: 'Please select sub-category' }
								]}
							>
								<Select
									onChange={val => handleChangeSubCategories(0, val)}
									allowClear
									placeholder="Select sub-category"
								>
									{
										sub_category_options.length > 0 && sub_category_options.map((option, index) => (
											<Select.Option
												key={index}
												value={option.value}
											>{option.text}</Select.Option>
										))
									}
								</Select>
							</Form.Item>
						) : ''
					}
					<Form.Item
						name="attachments_fields"
						label="Attachment"
					>
						<FileUploader
							style={{ cursor: 'pointer' }}
							handleChange={file => handleChangeAttachments(0, file)}
							name="file"
							types={['jpg', 'png', 'gif', 'jpeg', 'pdf', 'doc', 'docx']}
							multiple={false}
							children={
								<div style={{ width: '100%', backgroundColor: '#fafafa', border: '1px dashed #d9d9d9', padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center' }}>
									<UploadOutlined style={{ fontSize: 30, color: '#8B8B8B' }} />
									<p style={{ color: '#8B8B8B' }}>Upload File</p>
									{formState.attachments.length > 0 ? formState.attachments[0] ? `${formState.attachments[0].name}` : '' : ''}
								</div>
							}
						/>
					</Form.Item>
					<Form.Item
						name="details"
						label="Details"
						rules={[
							{ required: true, message: 'Please input details' }
						]}
					>
						<TextArea
							onChange={val => {
								const data = {
									name: 'details',
									value: val.target.value
								};
								onFieldChange(data);
							}}
							style={{ width: '100%' }}
						/>
					</Form.Item>
					<Form.Item>
						<Checkbox
							name="share_info"
							checked={share_info}
							onChange={val => {
								const data = {
									name: 'share_info',
									value: !share_info
								};
								onFieldChange(data);
							}}
						>Shared information with operator</Checkbox>
						{web_form ? (
							<p style={{ marginTop: 20 }}>{web_form.disclaimer}</p>
						) : ''}

					</Form.Item>
					<Row
						type="flex"
						justify="end"
					>
						<Form.Item>
							<Button
								loading={loadingSubmit}
								onClick={() => onSubmit()}
								style={{ background: '#003366', color: '#fff' }}
								disabled={formState.loading || formState.disableButton || loadingSubmit}
							>Submit</Button>
						</Form.Item>
					</Row>
				</Form>
			</div>
		</div>
	);
}

export default compose(
	withAlert()
)(WebFormDetailPage);
